<div class="page-container">
  
  <!-- HEADER -->
  <header>
    <h1>{{ 'team-recordings.title' | translate }}</h1>
    
    <!-- Filter Pills -->
    <div class="filters">
      @for (days of filterOptions; track days) {
        <button 
          class="filter-pill" 
          [class.active]="currentFilter() === days"
          (click)="setFilter(days)">
          <!-- Handle special case for 'All' (3650) in translation key lookup -->
          {{ 'team-recordings.filter-days.' + (days === 3650 ? 'all' : days) | translate }}
        </button>
      }
    </div>
  </header>

  <main class="content-area">

    <!-- ALERTS / RESTRICTIONS -->
    <!-- Private Recordings Hidden (Login Prompt) -->
    @if (hasPrivateRestricted()) {
      <div class="alert-box warning">
        <span class="icon">🔒</span>
        <!-- Note: We use innerHTML to render the <a> tag inside the translation, but click is handled by parent for safety in Angular -->
        <span [innerHTML]="'team-recordings.alerts.private-restricted' | translate"></span>
        @if (!isLoggedIn()){
          <span><a [href]="`/user/login?redirect=${router.url}`" class="login-link">{{ 'team-recordings.alerts.private-restricted-ask-login-1' | translate }}</a> {{ 'team-recordings.alerts.private-restricted-ask-login-2' | translate }}</span>
        }
      </div>
    }

    <!-- Unlisted Recordings Hidden (Invalid Key) -->
    @if (hasUnlistedRestricted()) {
      <div class="alert-box info">
        <span class="icon">⚠️</span>
        <span>{{ 'team-recordings.alerts.unlisted-restricted' | translate }}</span>
      </div>
    }

    <!-- LOADING -->
    @if (isLoading()) {
      <div class="loading-state">
        <div class="spinner"></div>
      </div>
    }

    <!-- ERROR -->
    @if (error()) {
      <div class="error-state">
        {{ error() | translate }} <!-- Assumes error is a translation key -->
      </div>
    }

    <!-- RECORDINGS LIST -->
    @if (!isLoading() && !error()) {
      
      @if (recordings().length > 0) {
        <div class="recordings-list">
          @for (rec of recordings(); track rec.id) {
            <!-- 
               CHANGED: Uses <a> tag with routerLink.
               Link format: /viewer/{id}?s={sharingKey}
               Only adds link if recording is ready.
            -->
            <a 
              class="recording-item" 
              [class.not-ready]="!rec.ready"
              [routerLink]="rec.ready && !rec.deleted ? ['/viewer', rec.id] : null"
              [queryParams]="rec.ready && !rec.deleted ? recordingParams : null">
              
              <div class="rec-info">
                <span class="rec-date">{{ rec.date | date:'medium' }}</span>
                <span class="rec-name">{{ rec.name || ('Unknown Event' | translate) }}</span>
              </div>

              <div class="rec-status">
                @if (rec.deleted) {
                  <span class="badge processing">{{ 'team-recordings.status.deleted' | translate }}</span>
                } @else if (rec.ready) {
                  <span class="badge ready">{{ 'team-recordings.status.ready' | translate }}</span>
                  <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" /></svg>
                } @else {
                  <span class="badge processing">{{ 'team-recordings.status.processing' | translate }}</span>
                }
              </div>
            </a>
          }
        </div>
      } @else {
        <!-- EMPTY STATE -->
        <div class="empty-state">
          <!-- If we have restricted content, the list might be empty because of that. 
               If NO restricted content and NO recordings, show "No Access". 
               If restricted content exists but list is empty, show "Empty Filter". -->
          @if (!hasPrivateRestricted() && !hasUnlistedRestricted()) {
            <p>{{ 'team-recordings.alerts.no-access' | translate }}</p>
          } @else {
            <p>{{ 'team-recordings.alerts.empty-filter' | translate }}</p>
          }
        </div>
      }
    }

  </main>
</div>
